import React, { useState, useEffect } from 'react';
import './navbar.css';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isTourDropdownOpen, setIsTourDropdownOpen] = useState(false);

  // Handle body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('nav-open');
    } else {
      document.body.classList.remove('nav-open');
    }

    return () => {
      document.body.classList.remove('nav-open');
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (!isMenuOpen) {
      setIsTourDropdownOpen(false);
    }
  };

  const toggleTourDropdown = () => {
    setIsTourDropdownOpen(!isTourDropdownOpen);
  };

  const closeAllMenus = () => {
    setIsMenuOpen(false);
    setIsTourDropdownOpen(false);
  };

  const handleDropdownLinkClick = () => {
    closeAllMenus();
  };

  const handleDropdownToggle = (e) => {
    e.preventDefault();
    toggleTourDropdown();
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
{/* Logo */}
<div className="nav-logo">
  <a href="/" onClick={closeAllMenus}>
    <img src="/logo192.png" alt="Logo" className="logo-eco" />
  </a>
</div>


        {/* Navigation Menu */}
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <a href="/" className="nav-link" onClick={closeAllMenus}>Home</a>
          </li>
          
          {/* Tour Packages Dropdown */}
          <li className="nav-item dropdown">
            <a 
              href="#!" 
              className="nav-link dropdown-toggle"
              onClick={handleDropdownToggle}
            >
              Tour Packages
              <span className={`dropdown-arrow ${isTourDropdownOpen ? 'open' : ''}`}>
                {window.innerWidth <= 768 ? '›' : '▼'}
              </span>
            </a>
            <ul className={`dropdown-menu ${isTourDropdownOpen ? 'active' : ''}`}>
                            <li className="dropdown-item">
                <a href="/airport-pickup-drop" className="dropdown-link" onClick={handleDropdownLinkClick}>
                  Airport Pickup & Drop
                </a>
              </li>
              <li className="dropdown-item">
                <a href="/tour4" className="dropdown-link" onClick={handleDropdownLinkClick}>
                  4-Day Beach Tour
                </a>
              </li>
              <li className="dropdown-item">
                <a href="/tour6" className="dropdown-link" onClick={handleDropdownLinkClick}>
                  6-Day Adventure Tour
                </a>
              </li>
              <li className="dropdown-item">
                <a href="/tour7" className="dropdown-link" onClick={handleDropdownLinkClick}>
                  7-Day Cultural & Wildlife
                </a>
              </li>
              {/* <li className="dropdown-item">
                <a href="/tour12" className="dropdown-link" onClick={handleDropdownLinkClick}>
                  12-Day Explore Sri Lanka
                </a>
              </li>
              <li className="dropdown-item">
                <a href="/tour14" className="dropdown-link" onClick={handleDropdownLinkClick}>
                  14-Day Ultimate Journey
                </a>
              </li> */}
            </ul>
          </li>

          <li className="nav-item">
            <a href="/bookings" className="nav-link" onClick={closeAllMenus}>Booking</a>
          </li>
          <li className="nav-item">
            <a href="/destination" className="nav-link" onClick={closeAllMenus}>Destinations</a>
          </li>
          <li className="nav-item">
            <a href="/aboutus" className="nav-link" onClick={closeAllMenus}>About Us</a>
          </li>
          <li className="nav-item">
            <a href="/contactus" className="nav-link" onClick={closeAllMenus}>Contact Us</a>
          </li>
          <li className="nav-item nav-cta">
            <a href="/bookings" className="nav-link cta-button" onClick={closeAllMenus}>Book Now</a>
          </li>
        </ul>

        {/* Mobile Menu Toggle */}
        <div className="nav-toggle" onClick={toggleMenu}>
          <span className={`bar ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`bar ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`bar ${isMenuOpen ? 'active' : ''}`}></span>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;